import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Button from 'builder/components/Button'

export const PercentWrapper = styled.div`
  padding: 10px 5px;
  background: ${Colors.Green10};
  border-radius: 8px;
  margin-right: 12px;
  width: fit-content;
  height: 40px;
`

export const PercentNeeded = styled.div`
  ${Typography.Tiny};
  ${FontWeights.DemiBold}
  border-radius: 4px;
  color: ${Colors.White};
  font-variant-numeric: tabular-nums;
  padding: 2px 3px;
  background: ${Colors.Green40};

  &:before {
    content: '+';
  }

  &:after {
    content: '%';
  }
`

export const TryAgainButtonWrapper = styled.div`
  display: flex;
`
export const TryAgainButton = styled(Button)(({ isDisabled }) => {
  return css`
    /* Desktop and Tablet/Body • Medium */
    ${Typography.Body}
    ${FontWeights.Medium};
    color: ${!isDisabled ? Colors.Blue50 : Colors.Neutral30};
    background: ${Colors.White};
    padding: 0;

    &:hover {
      color: ${!isDisabled ? Colors.Blue60 : Colors.Neutral30};
      background: ${Colors.White};
    }
    svg {
      position: unset !important;
    }
    span {
      margin-left: unset !important;
    }
  `
})
